import { AxiosError } from 'axios';
import { apiClient } from '@/lib/api-client';
import type { ApiResponse, LoginRequest, LoginResponse, RegisterRequest, User } from '@/types/api';

export async function login(data: LoginRequest): Promise<ApiResponse<LoginResponse>> {
  const response = await apiClient.post<ApiResponse<LoginResponse>>('/api/auth/login', data);
  return response.data;
}

export async function register(data: RegisterRequest): Promise<ApiResponse<null>> {
  const response = await apiClient.post<ApiResponse<null>>('/api/auth/register', data);
  return response.data;
}

export async function getCurrentUser(): Promise<ApiResponse<User>> {
  const response = await apiClient.get<ApiResponse<User>>('/api/auth/me');
  return response.data;
}

/**
 * Change the authenticated user's password via `POST /api/auth/change-password`.
 * Clears the server-side `mustChangePassword` flag on success. Throws an
 * `Error` carrying the server message on 4xx (e.g. password too short).
 */
export async function changePassword(payload: { newPassword: string }): Promise<void> {
  try {
    await apiClient.post<ApiResponse<unknown>>('/api/auth/change-password', payload);
  } catch (err) {
    if (err instanceof AxiosError && err.response) {
      const body = err.response.data as ApiResponse<unknown> | undefined;
      const message =
        body?.message ?? body?.errors?.[0] ?? 'Could not change password. Please try again.';
      throw new Error(message, { cause: err });
    }
    throw err;
  }
}
